module.exports = __webpack_public_path__ + "img/NOR.ec001395.png";